/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/purchase_order_line_items-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/purchase_order_line_items-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/purchase_order_line_items-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-purchase_order_line_items-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/purchase_order_line_items.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-10-26T15:51:14.830Z
 * Source config: config/entities/purchase_order_line_items-entity-config.ts
 * Public fields: 52/52 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const PurchaseOrderLineItemsSchema = Type.Object({
  id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // id field - primary key
  purchase_order_id: Type.String({ format: "uuid" }), // purchase_order_id field
  material_id: Type.String({ format: "uuid" }), // material_id field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  quantity: Type.Number(), // quantity field
  unit_cost: Type.Number(), // unit_cost field
  total_cost: Type.Number(), // total_cost field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  received_quantity: Type.Union([Type.Number(), Type.Null()]), // received_quantity field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  job_allocations: Type.Union([Type.String(), Type.Null()]), // job_allocations field
  lot_allocations: Type.Union([Type.String(), Type.Null()]), // lot_allocations field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field - auto-managed timestamp
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field - auto-managed timestamp
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  trig_status_name: Type.Union([Type.String(), Type.Null()]), // trig_status_name field - trigger-populated denormalized field
  trig_status_code: Type.Union([Type.String(), Type.Null()]), // trig_status_code field - trigger-populated denormalized field
  trig_status_color: Type.Union([Type.String(), Type.Null()]), // trig_status_color field - trigger-populated denormalized field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  trig_lot_number: Type.Union([Type.String(), Type.Null()]), // trig_lot_number field - trigger-populated denormalized field
  trig_lot_address: Type.Union([Type.String(), Type.Null()]), // trig_lot_address field - trigger-populated denormalized field
  trig_lot_square_footage: Type.Union([Type.String(), Type.Null()]), // trig_lot_square_footage field - trigger-populated denormalized field
  trig_lot_phase_name: Type.Union([Type.String(), Type.Null()]), // trig_lot_phase_name field - trigger-populated denormalized field
  trig_area_name: Type.Union([Type.String(), Type.Null()]), // trig_area_name field - trigger-populated denormalized field
  trig_area_sqft: Type.Union([Type.String(), Type.Null()]), // trig_area_sqft field - trigger-populated denormalized field
  trig_area_type_code: Type.Union([Type.String(), Type.Null()]), // trig_area_type_code field - trigger-populated denormalized field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  trig_material_color: Type.Union([Type.String(), Type.Null()]), // trig_material_color field - trigger-populated denormalized field
  redline_amount: Type.Union([Type.Number(), Type.Null()]), // redline_amount field
  trig_material_name: Type.Union([Type.String(), Type.Null()]), // trig_material_name field - trigger-populated denormalized field
  version: Type.Union([Type.Number(), Type.Null()]), // version field
  trig_material_unit_of_measure: Type.Union([Type.String(), Type.Null()]), // trig_material_unit_of_measure field - trigger-populated denormalized field
  slab_length: Type.Union([Type.Number(), Type.Null()]), // slab_length field
  slab_width: Type.Union([Type.Number(), Type.Null()]), // slab_width field
  slab_thickness: Type.Union([Type.String(), Type.Null()]), // slab_thickness field
  slab_sqft: Type.Union([Type.Number(), Type.Null()]), // slab_sqft field
  cost_per_sqft: Type.Union([Type.Number(), Type.Null()]), // cost_per_sqft field
  trig_material_department: Type.Union([Type.String(), Type.Null()]), // trig_material_department field - trigger-populated denormalized field
  trig_material_code: Type.Union([Type.String(), Type.Null()]), // trig_material_code field - trigger-populated denormalized field
  trig_material_manufacturer: Type.Union([Type.String(), Type.Null()]), // trig_material_manufacturer field - trigger-populated denormalized field
  pulled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // pulled_at field
  pulled_by: Type.Union([Type.String(), Type.Null()]), // pulled_by field
  finish: Type.Union([Type.String(), Type.Null()]), // finish field
  trig_material_vendor_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // trig_material_vendor_id field - trigger-populated denormalized field
  trig_material_vendor_name: Type.Union([Type.String(), Type.Null()]), // trig_material_vendor_name field - trigger-populated denormalized field
  trig_material_vendor_sku: Type.Union([Type.String(), Type.Null()]), // trig_material_vendor_sku field - trigger-populated denormalized field (materials.vendor_sku, card PO-SKU) so the vendor SKU rides onto the PO line and the vendor export
  department: Type.Union([Type.String(), Type.Null()]), // department field
  block_numbers: Type.Union([Type.String(), Type.Null()]), // block_numbers field
  line_number: Type.Union([Type.Number(), Type.Null()]), // line_number field - source line number from the vendor quote/PO (may be non-contiguous, e.g. Daltile 1,4,5,8)
  source_area_field_junction_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // source_area_field_junction_id field - the area_fields_junction row (lot + area + material) this line was ordered for; one line per (PO, source junction). NULL for manual and legacy lines
});

export const CreatePurchaseOrderLineItemsSchema = Type.Object({
  purchase_order_id: Type.String({ format: "uuid" }), // purchase_order_id field
  material_id: Type.String({ format: "uuid" }), // material_id field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  quantity: Type.Number(), // quantity field
  unit_cost: Type.Number(), // unit_cost field
  total_cost: Type.Number(), // total_cost field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  received_quantity: Type.Union([Type.Number(), Type.Null()]), // received_quantity field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  job_allocations: Type.Union([Type.String(), Type.Null()]), // job_allocations field
  lot_allocations: Type.Union([Type.String(), Type.Null()]), // lot_allocations field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  redline_amount: Type.Union([Type.Number(), Type.Null()]), // redline_amount field
  version: Type.Union([Type.Number(), Type.Null()]), // version field
  slab_length: Type.Union([Type.Number(), Type.Null()]), // slab_length field
  slab_width: Type.Union([Type.Number(), Type.Null()]), // slab_width field
  slab_thickness: Type.Union([Type.String(), Type.Null()]), // slab_thickness field
  slab_sqft: Type.Union([Type.Number(), Type.Null()]), // slab_sqft field
  cost_per_sqft: Type.Union([Type.Number(), Type.Null()]), // cost_per_sqft field
  pulled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // pulled_at field
  pulled_by: Type.Union([Type.String(), Type.Null()]), // pulled_by field
  finish: Type.Union([Type.String(), Type.Null()]), // finish field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  block_numbers: Type.Union([Type.String(), Type.Null()]), // block_numbers field
  line_number: Type.Union([Type.Number(), Type.Null()]), // line_number field - source line number from the vendor quote/PO (may be non-contiguous, e.g. Daltile 1,4,5,8)
  source_area_field_junction_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // source_area_field_junction_id field - the area_fields_junction row (lot + area + material) this line was ordered for; one line per (PO, source junction). NULL for manual and legacy lines
});

export const UpdatePurchaseOrderLineItemsSchema = Type.Object({
  purchase_order_id: Type.String({ format: "uuid" }), // purchase_order_id field
  material_id: Type.String({ format: "uuid" }), // material_id field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  quantity: Type.Number(), // quantity field
  unit_cost: Type.Number(), // unit_cost field
  total_cost: Type.Number(), // total_cost field
  status: Type.Union([Type.String(), Type.Null()]), // status field
  received_quantity: Type.Union([Type.Number(), Type.Null()]), // received_quantity field
  job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // job_id field
  lot_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lot_id field
  area_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // area_id field
  job_allocations: Type.Union([Type.String(), Type.Null()]), // job_allocations field
  lot_allocations: Type.Union([Type.String(), Type.Null()]), // lot_allocations field
  status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // status_id field
  notes: Type.Union([Type.String(), Type.Null()]), // notes field
  delivery_date: Type.Union([Type.String(), Type.Null()]), // delivery_date field
  redline_amount: Type.Union([Type.Number(), Type.Null()]), // redline_amount field
  version: Type.Union([Type.Number(), Type.Null()]), // version field
  slab_length: Type.Union([Type.Number(), Type.Null()]), // slab_length field
  slab_width: Type.Union([Type.Number(), Type.Null()]), // slab_width field
  slab_thickness: Type.Union([Type.String(), Type.Null()]), // slab_thickness field
  slab_sqft: Type.Union([Type.Number(), Type.Null()]), // slab_sqft field
  cost_per_sqft: Type.Union([Type.Number(), Type.Null()]), // cost_per_sqft field
  pulled_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // pulled_at field
  pulled_by: Type.Union([Type.String(), Type.Null()]), // pulled_by field
  finish: Type.Union([Type.String(), Type.Null()]), // finish field
  department: Type.Union([Type.String(), Type.Null()]), // department field
  block_numbers: Type.Union([Type.String(), Type.Null()]), // block_numbers field
  line_number: Type.Union([Type.Number(), Type.Null()]), // line_number field - source line number from the vendor quote/PO (may be non-contiguous, e.g. Daltile 1,4,5,8)
  source_area_field_junction_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // source_area_field_junction_id field - the area_fields_junction row (lot + area + material) this line was ordered for; one line per (PO, source junction). NULL for manual and legacy lines
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PurchaseOrderLineItemsRow = Static<typeof PurchaseOrderLineItemsSchema>;
export type PurchaseOrderLineItemsInsert = Static<typeof CreatePurchaseOrderLineItemsSchema>;
export type PurchaseOrderLineItemsUpdate = Static<typeof UpdatePurchaseOrderLineItemsSchema>;

// Legacy type aliases for backward compatibility
export type PurchaseOrderLineItems = PurchaseOrderLineItemsRow;
export type CreatePurchaseOrderLineItems = PurchaseOrderLineItemsInsert;
export type UpdatePurchaseOrderLineItems = Static<typeof UpdatePurchaseOrderLineItemsSchema>;

// Field configuration metadata
export const PurchaseOrderLineItemsFieldConfig = {
  filterable: ['id', 'purchase_order_id', 'material_id', 'job_id', 'lot_id', 'area_id', 'status_id', 'trig_material_vendor_id', 'trig_material_vendor_sku', 'line_number', 'source_area_field_junction_id'] as const,
  sortable: ['created_at', 'updated_at', 'line_number'] as const,
  searchable: [] as const,
  required: ['purchase_order_id', 'material_id', 'quantity', 'unit_cost', 'total_cost'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'trig_status_name', 'trig_status_code', 'trig_status_color', 'trig_lot_number', 'trig_lot_address', 'trig_lot_square_footage', 'trig_lot_phase_name', 'trig_area_name', 'trig_area_sqft', 'trig_area_type_code', 'trig_material_color', 'trig_material_name', 'trig_material_unit_of_measure', 'trig_material_department', 'trig_material_code', 'trig_material_manufacturer', 'trig_material_vendor_id', 'trig_material_vendor_name', 'trig_material_vendor_sku'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../../config/search/global-search-config.js';

export interface PurchaseOrderLineItemsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface PurchaseOrderLineItemsResponse {
  data: PurchaseOrderLineItems[] | null;
  error: Error | null;
  count?: number;
}

export interface SinglePurchaseOrderLineItemsResponse {
  data: PurchaseOrderLineItems | null;
  error: Error | null;
}
